import type { ChangeEvent } from 'react';

interface CampoProps {
  id?: string;
  rotulo?: string;
  valor: string;
  aoMudar: (valor: string) => void;
  placeholder?: string;
  inputMode?: 'text' | 'numeric' | 'tel';
  maxLength?: number;
  erro?: string | null;
  ajuda?: string;
  obrigatorio?: boolean;
  autoComplete?: string;
  aoSair?: () => void;
}

// Campo de texto da página dos pais: 48 px de altura, cantos 12 px.
export default function Campo({
  id,
  rotulo,
  valor,
  aoMudar,
  placeholder,
  inputMode = 'text',
  maxLength,
  erro,
  ajuda,
  obrigatorio,
  autoComplete,
  aoSair,
}: CampoProps) {
  const aoDigitar = (ev: ChangeEvent<HTMLInputElement>) => aoMudar(ev.target.value);

  return (
    <div className="w-full min-w-0">
      {rotulo && (
        <label
          htmlFor={id}
          className="mb-1.5 block text-[15px] font-semibold text-foreground-900"
        >
          {rotulo}
          {obrigatorio && <span className="ml-1 text-danger-600">*</span>}
        </label>
      )}
      <input
        id={id}
        type="text"
        inputMode={inputMode}
        value={valor}
        onChange={aoDigitar}
        onBlur={aoSair}
        placeholder={placeholder}
        maxLength={maxLength}
        autoComplete={autoComplete}
        className={`h-12 w-full min-w-0 rounded-xl border bg-white px-3.5 text-base text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 ${
          erro ? 'border-danger-500' : 'border-secondary-300'
        }`}
      />
      {erro ? (
        <p className="mt-1.5 flex items-start gap-1.5 text-sm text-danger-600" role="alert">
          <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
            <i className="ri-error-warning-line" aria-hidden />
          </span>
          {erro}
        </p>
      ) : ajuda ? (
        <p className="mt-1.5 text-sm text-foreground-500">{ajuda}</p>
      ) : null}
    </div>
  );
}

interface AreaProps {
  id?: string;
  rotulo?: string;
  valor: string;
  aoMudar: (valor: string) => void;
  placeholder?: string;
  erro?: string | null;
  linhas?: number;
}

// Caixa de texto (3 linhas por padrão).
export function Area({
  id,
  rotulo,
  valor,
  aoMudar,
  placeholder,
  erro,
  linhas = 3,
}: AreaProps) {
  return (
    <div className="w-full min-w-0">
      {rotulo && (
        <label htmlFor={id} className="mb-1.5 block text-[15px] font-semibold text-foreground-900">
          {rotulo}
        </label>
      )}
      <textarea
        id={id}
        rows={linhas}
        value={valor}
        onChange={(ev) => aoMudar(ev.target.value)}
        placeholder={placeholder}
        className={`w-full min-w-0 resize-none rounded-xl border bg-white px-3.5 py-3 text-base text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 ${
          erro ? 'border-danger-500' : 'border-secondary-300'
        }`}
      />
      {erro && (
        <p className="mt-1.5 text-sm text-danger-600" role="alert">
          {erro}
        </p>
      )}
    </div>
  );
}